import React from 'react'
import "./RoadMap.css"
import raod from "../Assets/roadmap.png"
import l_roc from "../Assets/left_roc.png"
import r_roc from "../Assets/r_roc.png"

export default function RoadMap() {
    return (
        <div className='main_road_map overflow-hidden position-relative' id='Roadmap'>
<div data-aos="fade-up">


            <h1 className='section_head gor_font text-center'>Road Map</h1>
            <h6 className='fs-2 text-white fw-bold text-center'>Project Launch 2024 – Pre-Sale</h6>
            <p className='text-center text-white nor_font fw-semibold'>57 million coins will be released to the public. We’ll announce weekly competitions and challenges with <br /> exciting prizes! We want to hear your voice!
            </p>
            </div>
            <div className='mt-5'>

                <img src={raod} className='w-100 d-none d-md-block bg_rod' alt="" />

                <div className="row z-2 mt-md-3 position-relative justify-content-between m-0">
                    <div className="col-md-4 col-lg-3 upper_row" data-aos="fade-right">
                        <div className='d-flex flex-column mb_card_raod '>
                        <h1 className='odo_font order-0 order-md-1 fs-1 fw-normal text-white text-center'>Phase 1</h1>
                            <p className='nor_font order-1 order-md-0 fw-semibold fs-5 text-white text-center'>
                           
                            Launch of the token
                            Website goes live
                            NFT collection with built-in utility
                            Staking options for NFTs
                            Launch of the marketplace
                            Achieve a market cap of $500k
                            </p>
                            
                        </div>
                    </div>
                    <div className="col-md-4 col-lg-3 mt-3 mt-md-0y upper_third"  data-aos="fade-up">
                        <div className='mb_card_raod'>


                            <h1 className='odo_font fs-1 fw-normal text-white text-center'>Phase 2
                            </h1>
                            <p className='nor_font fw-semibold fs-5 text-white text-center'>
                            Partnering with Twitter influencers
                            Launch of DEX advertisements
                            Sponsored ads on Twitter
                            Achieve a market cap of $1M


                            </p>
                        </div>
                    </div>
                    <div className="col-md-4 col-lg-3 mt-3 mt-md-0y upper_sec" data-aos="fade-left" >
                        <div className='d-flex flex-column mb_card_raod'>

                            <p className='nor_font order-1 order-md-0 fw-semibold fs-5 text-white text-center'>
                            Listing on CoinGecko
                            Listing on CoinMarketCap (CMC)
                            First centralized exchange (CEX) listing
                            Grow Twitter community to 5K followers
                            Grow Telegram group to 5K members
                            Engage YouTube influencers
                            Achieve a market cap of $10M
                            Launch of the game
                            1B market cap

                            </p>
                            <h1 className='odo_font order-0 order-md-1 fs-1 fw-normal text-white text-center'>Phase 3</h1>
                        </div>
                    </div>
                </div>
            </div>
            <img src={l_roc} className='d-none d-md-block l_roc' style={{width:"600px"}} alt="" />
            <img src={r_roc} className='d-none d-md-block r_roc' style={{bottom:"0"}} alt="" />
        </div>
    )
}
